import { Outlet, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { navigationService } from '@lib/services/other/navigationService.ts';

export function NavigationInitializer() {
  const navigate = useNavigate();

  useEffect(() => {
    console.log('NavigationInitializer is called');
    navigationService.setNavigate(navigate);
  }, [navigate]);

  return <Outlet />;
}
